import {
    DIC
} from '@/const/dic'
import {
    validateChinese
} from '@/util/validate'
export const teamDataOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewBtn: false,
    menuWidth: '300',
    defaultSort:{
        prop: 'createTime',
        order: 'descending'
    },
    column: [
        {
            label: "团队名称",
            prop: "name",
            type: "input"
        },
        {
            label: "团队等级",
            prop: "gradeName",
            type: "input"
        },
        {
            label: "团队人数",
            prop: "number",
            type: "input"
        },
        {
            label: "团队经验值",
            prop: "sufferValue",
            type: "input"
        },
        {
            label: "团队接单数",
            prop: "orderNumber",
            type: "input"
        },
        {
            label: "店铺账号",
            prop: "account",
            type: "input"
        },
        {
            label: "店铺法人名称",
            prop: "createName",
            type: "input"
        },
        {
            label: "店铺名称",
            prop: "shopName",
            type: "input"
        },
        {
            label: "状态",
            prop: "status",
            type: "input",
            solt: true,
            addVisdiplay: false,
            editVisdiplay: false
        }
    ]
};